import React from "react";
import AnimatedDialog from "../AnimatedDialog";

const SaveModal = ({
  heading,
  handleSubmit,
  handleClose,
  getMessage,
  isVisible = true,
}) => {
  return (
    <AnimatedDialog
      header
      heading={heading || "Save Changes"}
      isVisible={isVisible}
      permission
      acceptLabel="Yes"
      rejectLabel="No"
      handleAccept={handleSubmit}
      handleReject={handleClose}
    >
      <p>{getMessage()}</p>
    </AnimatedDialog>
  );
};

export default SaveModal;
